module.exports = __webpack_public_path__ + "static/media/jaylene-clark-owens.9d64c746.md";